module.exports = __webpack_public_path__ + "img/c-2.c0e202ef.jpg";